import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, contracterActions, manageActions } from '../../store/actions'
import Input from '../input'
import history from '../../route/history'
import { valid } from '../../hook/valid'

const Contracter = (props) => {
  const { contracter } = props

  const [state, setState] = useState({
    registNo: '',
    uthUserId: '',
  })

  useEffect(() => {
    //문서 채번 콜백
    if (props.totalData?.step1?.docid) {
      sessionStorage.setItem(props.totalData?.step1.docid, JSON.stringify(props.totalData))
      window.location.replace('/service/apply/1?id=' + props.totalData?.step1.docid)
      props.close()
      return
    }

    props.getGroupInfo()
  }, [props.totalData])

  //사업자 정보 조회
  useEffect(() => {
    props.isSearch &&
      setState({
        ...state,
        registNo: props.groupInfo?.groupRegistno,
      })
  }, [props.isSearch])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
  }

  const handleClose = () => {
    props.close()
    window.location.replace('/service/inbox')
  }

  return (
    <React.Fragment>
      <div className="modal-overlay normal">
        <div className="modal modal-large">
          <div className="modal-content">
            <div className="modal-header flex-sb">
              <div className="modal-title dis-flex">
                구매확인서 발급신청
                <button type="button" className="icon-close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>

            <div className="modal-body">
              <div className="modal-description">uTrade 서비스 정보 확인</div>
              <div className="madal-login">
                <div className="flex-sb-m m-b-10 ">
                  <span className="title">사업자번호</span>

                  <Input
                    readOnly={true}
                    type={'text'}
                    id="registNo"
                    name="registNo"
                    className="form-control input-text"
                    placeholder="사업자번호"
                    inputTitle={'사업자번호'}
                    message={'사업자번호'}
                    length={10}
                    value={state.registNo}
                    onChange={handleChange}
                    required={true}
                    flow={'up'}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-white" onClick={handleClose} F>
                취 소{' '}
              </button>
              <button className="btn btn-dark-blue" onClick={() => props.getDocNum(state)}>
                확 인
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    contracter: state.contracter,
    totalData: state.contracter.data,
    groupInfo: state.manage?.data,
    isSearch: state.manage?.isSearch,
  }
}

const actionCreators = {
  getGroupInfo: manageActions.getGroupInfo,
  toggleType: contracterActions.toggleType,
  close: contracterActions.close,
  getDocNum: contracterActions.getDocNum,
  success: alertActions.success,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(Contracter)
